import { applyMiddleware, compose, createStore as _createStore } from 'redux'
import { browserHistory, Router } from 'react-router'
import thunk from 'redux-thunk'
import { asyncMiddleware } from './asyncMiddleware';
import { makeRootReducer } from './reducer';
import { updateLocation } from './location'
import { preloadMiddleware, preloadReducer } from './preload';

export function createPreloadStore(http, history, routes, reducer, initialState, middlewares = []) {

  middlewares.push(preloadMiddleware(history, routes));

  return createStore(http, {
    ...reducer,
    pagePreload: preloadReducer
  }, initialState, middlewares);
}

export function createStore(http, reducer, initialState, middlewares = []) {

  middlewares = middlewares.concat([
    thunk,
    asyncMiddleware(http),
  ]);

  let composeEnhancers = compose;
  if (__DEVELOPMENT__) {
    const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension;
    }
  }
  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = _createStore(
    makeRootReducer(reducer),
    initialState,
    composeEnhancers(
      applyMiddleware(...middlewares),
    )
  )
  store.asyncReducers = {}

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  if(browserHistory) {
    store.unsubscribeHistory = browserHistory.listen(updateLocation(store))
  }

  //if (module.hot) {
  //  module.hot.accept('./reducer', () => {
  //    const makeRootReducer = require('./reducer').makeRootReducer;
  //    store.replaceReducer(makeRootReducer(store.asyncReducers))
  //  })
  //}


  return store;
}



// WEBPACK FOOTER //
// ../~/shared/src/utils/redux/createStore.js